import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 32 32";
const ClockIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16 4.28613C9.373 4.28613 4 9.65913 4 16.2861C4 22.9131 9.373 28.2861 16 28.2861C22.627 28.2861 28 22.9131 28 16.2861C28 9.65913 22.627 4.28613 16 4.28613ZM17 17.2861H8.995C8.445 17.2861 8 16.8411 8 16.2911V16.2801C8 15.7311 8.445 15.2861 8.995 15.2861H15V7.28113C15 6.73113 15.445 6.28613 15.995 6.28613H16.006C16.555 6.28613 17 6.73113 17 7.28113V17.2861Z",
      fill: rest.fill
    }
  ) });
};
export {
  ClockIcon
};
